module.exports = __webpack_public_path__ + "static/img/px_right.92117b83.png";